import { MapTo } from '@adobe/aem-react-editable-components';
import BrowseCards, { BrowseCardsEditConfig } from './BrowseCards';

export default MapTo('cob-corp-acquisition/components/creditonebank/browse-cards')(BrowseCards, BrowseCardsEditConfig);